import { ContractDamage, ContractHazard } from "@inrev/common";
import type { FieldValues } from "react-hook-form";
import { contractDamageOptions, contractHazardOptions } from "../../../constants";
import {
	FormCheckboxGroupComponent,
	type FormCheckboxGroupComponentProps,
} from "../../form/fieldLayouts/FormCheckboxGroupComponent";

type ContractSelectionFieldProps<TFieldValues extends FieldValues> = Omit<
	FormCheckboxGroupComponentProps<TFieldValues>,
	"options" | "noneValue"
>;

export const ContractDamagesField = <TFieldValues extends FieldValues>(
	props: ContractSelectionFieldProps<TFieldValues>,
) => (
	<FormCheckboxGroupComponent
		options={contractDamageOptions}
		noneValue={ContractDamage.none}
		{...props}
	/>
);

export const ContractHazardsField = <TFieldValues extends FieldValues>(
	props: ContractSelectionFieldProps<TFieldValues>,
) => (
	<FormCheckboxGroupComponent
		options={contractHazardOptions}
		noneValue={ContractHazard.none}
		{...props}
	/>
);
